function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "isLoading", "onButtonClose", "title", "withCloseButton"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from "react";
import classNamesMaker from "classnames";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { getAuthorizedRestProps } from "#library/utils/propsUtil";
import { getReactElementType } from "#library/utils/reactElement";
import { MAIN_THEME } from "#library/constants/skeleton";
import { Text, TEXT_COLORS, TEXT_WEIGHTS, TEXT_TYPES } from "#library/components/Text/Text";
import { Link } from "#library/components/Link/Link";
import { Icon, ICON_SIZES } from "#library/components/Icon/Icon";
import { isTypeHasTitleRequired } from "#library/components/ElementMessage/misc/utils";
import { useTheme } from "#library/components/ElementMessage/ThemeManagement";
import { ElementMessageSymbol } from "#library/components/ElementMessage/Symbol/ElementMessageSymbol";
import IconCross from "#library/assets/icons/jds_cross.svg";
import "react-loading-skeleton/dist/skeleton.css?raw";
import styles from "#library/components/ElementMessage/elementMessage.module.css";
import { propTypes, defaultProps } from "./propTypes";
export var ElementMessageLayout = function ElementMessageLayout(_ref) {
  var children = _ref.children,
    isLoading = _ref.isLoading,
    onButtonClose = _ref.onButtonClose,
    title = _ref.title,
    withCloseButton = _ref.withCloseButton,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useTheme = useTheme(),
    type = _useTheme.type,
    theme = _useTheme.theme;
  if (isTypeHasTitleRequired(type) && !title && !isLoading) {
    throw new Error("[ElementMessage.".concat(type, "] Please provide a valid \"title\" props"));
  }
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    showElementMessage = _useState2[0],
    setShowElementMessage = _useState2[1];
  var onClose = function onClose() {
    setShowElementMessage(false);
    if (onButtonClose) {
      onButtonClose();
    }
  };
  var mainClassNames = classNamesMaker(styles["jds-ElementMessage"], styles["jds-ElementMessage--".concat(type)], styles["jds-ElementMessage--".concat(theme)], _defineProperty({}, styles["jds-ElementMessage--unshownNotification"], !showElementMessage));
  var text = React.Children.map(children, function (child) {
    var childName = getReactElementType(child);
    if (!["string", Link.name].includes(childName)) {
      console.warn("[ElementMessage.".concat(type, "] recommend to use pure strings, Link or Router Link. Received ").concat(childName, " has child instead."));
    }
    return child;
  });
  var authorizedRestProps = _objectSpread({}, getAuthorizedRestProps(restProps));
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement(SkeletonTheme, MAIN_THEME, /*#__PURE__*/React.createElement("div", _extends({}, authorizedRestProps, {
      "aria-atomic": "true",
      "aria-busy": isLoading,
      "aria-live": "polite",
      className: mainClassNames,
      "data-e2e": "ElementMessage--".concat(type),
      role: "alert"
    }), /*#__PURE__*/React.createElement(ElementMessageSymbol, {
      type: type
    }), /*#__PURE__*/React.createElement("div", {
      className: styles["jds-ElementMessage__content"],
      "data-e2e": "ElementMessage__content"
    }, title && /*#__PURE__*/React.createElement(Text, {
      className: styles["jds-ElementMessage__title"],
      tag: "p",
      color: TEXT_COLORS.BLACK,
      weight: TEXT_WEIGHTS.BOLD,
      resetSpacing: true
    }, isLoading ? /*#__PURE__*/React.createElement(Skeleton, {
      width: "40%"
    }) : title), (text || isLoading) && /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      color: TEXT_COLORS.BLACK,
      type: TEXT_TYPES.SMALL,
      resetSpacing: true
    }, isLoading ? /*#__PURE__*/React.createElement(Skeleton, null) : text)), !isLoading && withCloseButton && /*#__PURE__*/React.createElement("button", {
      onClick: onClose,
      className: styles["jds-ElementMessage__close"],
      "aria-label": "close",
      type: "button",
      "data-e2e": "ElementMessage__closeButton"
    }, /*#__PURE__*/React.createElement(Icon, {
      xlinkHref: "#".concat(IconCross.id),
      size: ICON_SIZES.BIG
    }))))
  );
};
ElementMessageLayout.defaultProps = _objectSpread({}, defaultProps);
ElementMessageLayout.propTypes = _objectSpread({}, propTypes);